module.exports = __webpack_public_path__ + "img/cooperate_yh_02@2x.2a49562b.png";